import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LayoutProvider } from "./components/LayoutProvider";
import { RegisterPage } from "./pages/auth/register";
import { VerificationPage } from "./pages/auth/verification";
import { WelcomePage } from "./pages/auth/welcome";
import { SignInPage } from "./pages/auth/signin";
import DashboardLayout from "./components/LayoutProvider/DashbaoardLayout";
import CreateVehicle from "./pages/vehicle/CreateVehicle";
import VehiclesPage from "./pages/vehicle/Vehicles";
import { Dashboard } from "./pages/dashboard";
import RentalRecords from "./pages/rental-operations";
import CreateTransaction from "./pages/rental-operations/create-transaction";
import useAuth from "./hooks/useAuth";
import PageLayout from "./components/LayoutProvider/PageLayout";
import Rental from "./pages/rental-operations/rental";
import Location from "./pages/rental-operations/location";
import SettingsPage from "./pages/settings";
import VehicleDetailsPage from "./pages/vehicle/vehicle-details";
import VehicleHistoryPage from "./pages/vehicle/vehicle-history";
import ResetPassword from "./pages/auth/ResetPassword";
import ModifyVehicle from "./pages/vehicle/ModifyVehicle";
import Payouts from "./pages/payouts";

export default function Router() {
  const { token } = useAuth();
  return (
    <BrowserRouter>
      <Routes>
        {/* Authentication Routes Wrapped in LayoutProvider */}
        <Route element={<LayoutProvider />}>
          <Route path="/" element={<Navigate to={!token ?  "/signin" : "/dashboard"} replace />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        {/* Dashboard Routes Wrapped in DashboardLayout */}
        <Route element={<DashboardLayout />}> 
          {/* <Route path="/dashboard" element={<CreateVehicle />} /> */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/payouts" element={<Payouts />} />
          <Route path="/vehicles/create-vehicle" element={<CreateVehicle />} />
          <Route path="/vehicles/:id/modify-vehicle" element={<ModifyVehicle />} />
          <Route path="/vehicles/" element={<VehiclesPage />} />
          <Route path="/vehicles/:id" element={<VehicleDetailsPage />} />
          <Route path="/vehicles/:id/history/:requestId" element={<VehicleHistoryPage />} />
          <Route path="rentals" element={<PageLayout>
            <RentalRecords />
          </PageLayout>} />
          <Route path="rentals/:id" element={<PageLayout title="Rental Details">
            <Rental />
          </PageLayout>} />
          <Route path="rentals/:id/location" element={<PageLayout title="Rental Details">
            <Location />
          </PageLayout>} />
          {/* <Route path="/rentals/" element={<RentalRecords />} />
          <Route path="/rentals/pending/:id" element={<RentalRecords />} />
          <Route path="/rentals/active/:id" element={<RentalRecords />} />
          <Route path="/rentals/completed/:id" element={<RentalRecords />} /> */}
          <Route path="/rentals/create-transaction/" element={<CreateTransaction />} />
          <Route path="/settings/" element={<SettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
